export * from './lib/shared-mobile.module';
